import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { PrinterUserRequest } from "src/app/wings-mobile/models/receiving/printer/printerUsers-request.model";
import { Globals } from "src/app/wings-mobile/shared/globals/globals";
import { SearchPrintRequest } from "../../models/picked-and-packed/search-print-request.model";

@Injectable({
	providedIn: 'root'
})
export class PrinterService {

	printerUser: PrinterUserRequest;
	searchPrintResquest: SearchPrintRequest;

	endpoint: string = environment.inbound_url + '/api/v1/staging';

	constructor(private http: HttpClient, private global: Globals) {
		this.http = http;
		this.global = global;
	}

	getPrinterUser(): PrinterUserRequest {
		this.printerUser = {
			userC: this.global.user.userName,
			language: this.global.user.language,
			bkWarehouseUidK: this.global.user.warehouse.warehouseUidK,
			subDivisionUidK: this.global.user.warehouse.bkSubDivisionUidD,
			siteCode: this.global.tokenData.fordSiteCode
		};
		return this.printerUser;
	}

	getPrinterUserJab(): SearchPrintRequest {
		this.searchPrintResquest = {
			bkCdsidC: this.global.user.userName,
			printerConfig: {
				printerTypeC: "LASER",
				subDivisionUidD: this.global.user.warehouse.bkSubDivisionUidD,
				documentType: {
					bkDocumentTypeC: "PACKING_LIST"
				},
				warehouse: {
					warehouseUidK: this.global.user.warehouse.warehouseUidK,
					bkSubDivisionUidD: this.global.user.warehouse.bkSubDivisionUidD,
					buildingCodeC: this.global.user.warehouse.buildingCodeC
				}
			}
		};
		return this.searchPrintResquest
	}

	hasQuery(): any {
		const printUser = this.getPrinterUser();
		const URL = environment.inbound_url + '/api/v1/staging/checkPrinters';
		return this.http.post<any>(URL, printUser);
	}

	hasQueryToPrint(): any {
		let printUser = this.getPrinterUserJab();
		const URL = environment.backend_Jab_url + 'searchPrint/searchToPrint';
		return this.http.post<any>(URL, printUser);
	}
}
